import Stages from './Stages';

export default Stages;
